import { useFetchCirclesQuery, useFetchUserGroupsQuery, useFetchUserCoursesQuery } from '../searchApi';

export const useCircles = (params = {}) => {
  return useFetchCirclesQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      circles: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useUserGroups = (params = {}) => {
  return useFetchUserGroupsQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      userGroups: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useUserCourses = (params = {}) => {
  return useFetchUserCoursesQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      userCourses: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};
